module.exports = __webpack_public_path__ + "img/logo.7035a6f7.png";